export const fontAwesomeicons = [
    {
      'class': 'far fa-address-book',
      'name': 'address-book'
    }, {
      'class': 'far fa-address-card',
      'name': 'address-card'
    }, {
      'class': 'far fa-arrow-alt-circle-down',
      'name': 'arrow-alt-circle-down'
    }, {
      'class': 'far fa-arrow-alt-circle-left',
      'name': 'arrow-alt-circle-left'
    }, {
      'class': 'far fa-arrow-alt-circle-right',
      'name': 'arrow-alt-circle-right'
    }, {
      'class': 'far fa-arrow-alt-circle-up',
      'name': 'arrow-alt-circle-up'
    }, {
      'class': 'far fa-bell',
      'name': 'bell'
    }, {
      'class': 'far fa-bell-slash',
      'name': 'bell-slash'
    }, {
      'class': 'far fa-bookmark',
      'name': 'bookmark'
    }, {
      'class': 'far fa-building',
      'name': 'building'
    }, {
      'class': 'far fa-calendar',
      'name': 'calendar'
    }, {
      'class': 'far fa-calendar-alt',
      'name': 'calendar-alt'
    }, {
      'class': 'far fa-calendar-check',
      'name': 'calendar-check'
    }, {
      'class': 'far fa-calendar-minus',
      'name': 'calendar-minus'
    }, {
      'class': 'far fa-calendar-plus',
      'name': 'calendar-plus'
    }, {
      'class': 'far fa-calendar-times',
      'name': 'calendar-times'
    }, {
      'class': 'far fa-caret-square-down',
      'name': 'caret-square-down'
    }, {
      'class': 'far fa-caret-square-left',
      'name': 'caret-square-left'
    }, {
      'class': 'far fa-caret-square-right',
      'name': 'caret-square-right'
    }, {
      'class': 'far fa-caret-square-up',
      'name': 'caret-square-up'
    }, {
      'class': 'far fa-chart-bar',
      'name': 'chart-bar'
    }, {
      'class': 'far fa-check-circle',
      'name': 'check-circle'
    }, {
      'class': 'far fa-check-square',
      'name': 'check-square'
    }, {
      'class': 'far fa-circle',
      'name': 'circle'
    }, {
      'class': 'far fa-clipboard',
      'name': 'clipboard'
    }, {
      'class': 'far fa-clock',
      'name': 'clock'
    }, {
      'class': 'far fa-clone',
      'name': 'clone'
    }, {
      'class': 'far fa-closed-captioning',
      'name': 'closed-captioning'
    }, {
      'class': 'far fa-comment',
      'name': 'comment'
    }, {
      'class': 'far fa-comment-alt',
      'name': 'comment-alt'
    }, {
      'class': 'far fa-comment-dots',
      'name': 'comment-dots'
    }, {
      'class': 'far fa-comments',
      'name': 'comments'
    }, {
      'class': 'far fa-compass',
      'name': 'compass'
    }, {
      'class': 'far fa-copy',
      'name': 'copy'
    }, {
      'class': 'far fa-copyright',
      'name': 'copyright'
    }, {
      'class': 'far fa-credit-card',
      'name': 'credit-card'
    }, {
      'class': 'far fa-dot-circle',
      'name': 'dot-circle'
    }, {
      'class': 'far fa-edit',
      'name': 'edit'
    }, {
      'class': 'far fa-envelope',
      'name': 'envelope'
    }, {
      'class': 'far fa-envelope-open',
      'name': 'envelope-open'
    }, {
      'class': 'far fa-eye',
      'name': 'eye'
    }, {
      'class': 'far fa-eye-slash',
      'name': 'eye-slash'
    }, {
      'class': 'far fa-file',
      'name': 'file'
    }, {
      'class': 'far fa-file-alt',
      'name': 'file-alt'
    }, {
      'class': 'far fa-file-archive',
      'name': 'file-archive'
    }, {
      'class': 'far fa-file-audio',
      'name': 'file-audio'
    }, {
      'class': 'far fa-file-code',
      'name': 'file-code'
    }, {
      'class': 'far fa-file-excel',
      'name': 'file-excel'
    }, {
      'class': 'far fa-file-image',
      'name': 'file-image'
    }, {
      'class': 'far fa-file-pdf',
      'name': 'file-pdf'
    }, {
      'class': 'far fa-file-powerpoint',
      'name': 'file-powerpoint'
    }, {
      'class': 'far fa-file-video',
      'name': 'file-video'
    }, {
      'class': 'far fa-file-word',
      'name': 'file-word'
    }, {
      'class': 'far fa-flag',
      'name': 'flag'
    }, {
      'class': 'far fa-folder',
      'name': 'folder'
    }, {
      'class': 'far fa-folder-open',
      'name': 'folder-open'
    }, {
      'class': 'far fa-gem',
      'name': 'gem'
    }, {
      'class': 'far fa-hand-lizard',
      'name': 'hand-lizard'
    }, {
      'class': 'far fa-hand-paper',
      'name': 'hand-paper'
    }, {
      'class': 'far fa-hand-peace',
      'name': 'hand-peace'
    }, {
      'class': 'far fa-hand-point-down',
      'name': 'hand-point-down'
    }, {
      'class': 'far fa-hand-point-left',
      'name': 'hand-point-left'
    }, {
      'class': 'far fa-hand-point-right',
      'name': 'hand-point-right'
    }, {
      'class': 'far fa-hand-point-up',
      'name': 'hand-point-up'
    }, {
      'class': 'far fa-hand-pointer',
      'name': 'hand-pointer'
    }, {
      'class': 'far fa-hand-rock',
      'name': 'hand-rock'
    }, {
      'class': 'far fa-hand-scissors',
      'name': 'hand-scissors'
    }, {
      'class': 'far fa-hand-spock',
      'name': 'hand-spock'
    }, {
      'class': 'far fa-handshake',
      'name': 'handshake'
    }, {
      'class': 'far fa-hdd',
      'name': 'hdd'
    }, {
      'class': 'far fa-heart',
      'name': 'heart'
    }, {
      'class': 'far fa-hospital',
      'name': 'hospital'
    }, {
      'class': 'far fa-hourglass',
      'name': 'hourglass'
    }, {
      'class': 'far fa-id-badge',
      'name': 'id-badge'
    }, {
      'class': 'far fa-id-card',
      'name': 'id-card'
    }, {
      'class': 'far fa-image',
      'name': 'image'
    }, {
      'class': 'far fa-images',
      'name': 'images'
    }, {
      'class': 'far fa-keyboard',
      'name': 'keyboard'
    }, {
      'class': 'far fa-life-ring',
      'name': 'life-ring'
    }, {
      'class': 'far fa-lightbulb',
      'name': 'lightbulb'
    }, {
      'class': 'far fa-list-alt',
      'name': 'list-alt'
    }, {
      'class': 'far fa-map',
      'name': 'map'
    }, {
      'class': 'far fa-minus-square',
      'name': 'minus-square'
    }, {
      'class': 'far fa-money-bill-alt',
      'name': 'money-bill-alt'
    }, {
      'class': 'far fa-moon',
      'name': 'moon'
    }, {
      'class': 'far fa-newspaper',
      'name': 'newspaper'
    }, {
      'class': 'far fa-object-group',
      'name': 'object-group'
    }, {
      'class': 'far fa-object-ungroup',
      'name': 'object-ungroup'
    }, {
      'class': 'far fa-paper-plane',
      'name': 'paper-plane'
    }, {
      'class': 'far fa-pause-circle',
      'name': 'pause-circle'
    }, {
      'class': 'far fa-play-circle',
      'name': 'play-circle'
    }, {
      'class': 'far fa-plus-square',
      'name': 'plus-square'
    }, {
      'class': 'far fa-question-circle',
      'name': 'question-circle'
    }, {
      'class': 'far fa-registered',
      'name': 'registered'
    }, {
      'class': 'far fa-save',
      'name': 'save'
    }, {
      'class': 'far fa-share-square',
      'name': 'share-square'
    },  {
      'class': 'far fa-snowflake',
      'name': 'snowflake'
    }, {
      'class': 'far fa-square',
      'name': 'square'
    }, {
      'class': 'far fa-star',
      'name': 'star'
    }, {
      'class': 'far fa-star-half',
      'name': 'star-half'
    }, {
      'class': 'far fa-sticky-note',
      'name': 'sticky-note'
    }, {
      'class': 'far fa-stop-circle',
      'name': 'stop-circle'
    }, {
      'class': 'far fa-sun',
      'name': 'sun'
    }, {
      'class': 'far fa-thumbs-down',
      'name': 'thumbs-down'
    }, {
      'class': 'far fa-thumbs-up',
      'name': 'thumbs-up'
    }, {
      'class': 'far fa-times-circle',
      'name': 'times-circle'
    }, {
      'class': 'far fa-trash-alt',
      'name': 'trash-alt'
    }, {
      'class': 'far fa-user',
      'name': 'user'
    }, {
      'class': 'far fa-user-circle',
      'name': 'user-circle'
    }, {
      'class': 'far fa-window-close',
      'name': 'window-close'
    }, {
      'class': 'far fa-window-maximize',
      'name': 'window-maximize'
    }, {
      'class': 'far fa-window-minimize',
      'name': 'window-minimize'
    }, {
      'class': 'far fa-window-restore',
      'name': 'window-restore'
    }
    ];
    
    export const simpleLineIcons = [
    {class: 'icon-user', name: 'icon-user'},
    {class: 'icon-people', name: 'icon-people'},
    {class: 'icon-user-female', name: 'icon-user-female'},
    {class: 'icon-user-follow', name: 'icon-user-follow'},
    {class: 'icon-user-following', name: 'icon-user-following'},
    {class: 'icon-user-unfollow', name: 'icon-user-unfollow'},
    {class: 'icon-login', name: 'icon-login'},
    {class: 'icon-logout', name: 'icon-logout'},
    {class: 'icon-emotsmile', name: 'icon-emotsmile'},
    {class: 'icon-phone', name: 'icon-phone'},
    {class: 'icon-call-end', name: 'icon-call-end'},
    {class: 'icon-call-in', name: 'icon-call-in'},
    {class: 'icon-call-out', name: 'icon-call-out'},
    {class: 'icon-map', name: 'icon-map'},
    {class: 'icon-location-pin', name: 'icon-location-pin'},
    {class: 'icon-direction', name: 'icon-direction'},
    {class: 'icon-directions', name: 'icon-directions'},
    {class: 'icon-compass', name: 'icon-compass'},
    {class: 'icon-layers', name: 'icon-layers'},
    {class: 'icon-menu', name: 'icon-menu'},
    {class: 'icon-list', name: 'icon-list'},
    {class: 'icon-options-vertical', name: 'icon-options-vertical'},
    {class: 'icon-options', name: 'icon-options'},
    {class: 'icon-arrow-down', name: 'icon-arrow-down'},
    {class: 'icon-arrow-left', name: 'icon-arrow-left'},
    {class: 'icon-arrow-right', name: 'icon-arrow-right'},
    {class: 'icon-arrow-up', name: 'icon-arrow-up'},
    {class: 'icon-arrow-up-circle', name: 'icon-arrow-up-circle'},
    {class: 'icon-arrow-left-circle', name: 'icon-arrow-left-circle'},
    {class: 'icon-arrow-right-circle', name: 'icon-arrow-right-circle'},
    {class: 'icon-arrow-down-circle', name: 'icon-arrow-down-circle'},
    {class: 'icon-check', name: 'icon-check'},
    {class: 'icon-clock', name: 'icon-clock'},
    {class: 'icon-plus', name: 'icon-plus'},
    {class: 'icon-close', name: 'icon-close'},
    {class: 'icon-trophy', name: 'icon-trophy'},
    {class: 'icon-screen-smartphone', name: 'icon-screen-smartphone'},
    {class: 'icon-screen-desktop', name: 'icon-screen-desktop'},
    {class: 'icon-plane', name: 'icon-plane'},
    {class: 'icon-notebook', name: 'icon-notebook'},
    {class: 'icon-mustache', name: 'icon-mustache'},
    {class: 'icon-mouse', name: 'icon-mouse'},
    {class: 'icon-magnet', name: 'icon-magnet'},
    {class: 'icon-energy', name: 'icon-energy'},
    {class: 'icon-disc', name: 'icon-disc'},
    {class: 'icon-cursor', name: 'icon-cursor'},
    {class: 'icon-cursor-move', name: 'icon-cursor-move'},
    {class: 'icon-crop', name: 'icon-crop'},
    {class: 'icon-chemistry', name: 'icon-chemistry'},
    {class: 'icon-speedometer', name: 'icon-speedometer'},
    {class: 'icon-shield', name: 'icon-shield'},
    {class: 'icon-screen-tablet', name: 'icon-screen-tablet'},
    {class: 'icon-magic-wand', name: 'icon-magic-wand'},
    {class: 'icon-hourglass', name: 'icon-hourglass'},
    {class: 'icon-graduation', name: 'icon-graduation'},
    {class: 'icon-ghost', name: 'icon-ghost'},
    {class: 'icon-game-controller', name: 'icon-game-controller'},
    {class: 'icon-fire', name: 'icon-fire'},
    {class: 'icon-eyeglass', name: 'icon-eyeglass'},
    {class: 'icon-envelope-open', name: 'icon-envelope-open'},
    {class: 'icon-envelope-letter', name: 'icon-envelope-letter'},
    {class: 'icon-bell', name: 'icon-bell'},
    {class: 'icon-badge', name: 'icon-badge'},
    {class: 'icon-anchor', name: 'icon-anchor'},
    {class: 'icon-wallet', name: 'icon-wallet'},
    {class: 'icon-vector', name: 'icon-vector'},
    {class: 'icon-speech', name: 'icon-speech'},
    {class: 'icon-puzzle', name: 'icon-puzzle'},
    {class: 'icon-printer', name: 'icon-printer'},
    {class: 'icon-present', name: 'icon-present'},
    {class: 'icon-playlist', name: 'icon-playlist'},
    {class: 'icon-pin', name: 'icon-pin'},
    {class: 'icon-picture', name: 'icon-picture'},
    {class: 'icon-handbag', name: 'icon-handbag'},
    {class: 'icon-globe-alt', name: 'icon-globe-alt'},
    {class: 'icon-globe', name: 'icon-globe'},
    {class: 'icon-folder-alt', name: 'icon-folder-alt'},
    {class: 'icon-folder', name: 'icon-folder'},
    {class: 'icon-film', name: 'icon-film'},
    {class: 'icon-feed', name: 'icon-feed'},
    {class: 'icon-drop', name: 'icon-drop'},
    {class: 'icon-drawer', name: 'icon-drawer'},
    {class: 'icon-docs', name: 'icon-docs'},
    {class: 'icon-doc', name: 'icon-doc'},
    {class: 'icon-diamond', name: 'icon-diamond'},
    {class: 'icon-cup', name: 'icon-cup'},
    {class: 'icon-calculator', name: 'icon-calculator'},
    {class: 'icon-bubbles', name: 'icon-bubbles'},
    {class: 'icon-briefcase', name: 'icon-briefcase'},
    {class: 'icon-book-open', name: 'icon-book-open'},
    {class: 'icon-basket-loaded', name: 'icon-basket-loaded'},
    {class: 'icon-basket', name: 'icon-basket'},
    {class: 'icon-bag', name: 'icon-bag'},
    {class: 'icon-action-undo', name: 'icon-action-undo'},
    {class: 'icon-action-redo', name: 'icon-action-redo'},
    {class: 'icon-wrench', name: 'icon-wrench'},
    {class: 'icon-umbrella', name: 'icon-umbrella'},
    {class: 'icon-trash', name: 'icon-trash'},
    {class: 'icon-tag', name: 'icon-tag'},
    {class: 'icon-support', name: 'icon-support'},
    {class: 'icon-frame', name: 'icon-frame'},
    {class: 'icon-size-fullscreen', name: 'icon-size-fullscreen'},
    {class: 'icon-size-actual', name: 'icon-size-actual'},
    {class: 'icon-shuffle', name: 'icon-shuffle'},
    {class: 'icon-share-alt', name: 'icon-share-alt'},
    {class: 'icon-share', name: 'icon-share'},
    {class: 'icon-rocket', name: 'icon-rocket'},
    {class: 'icon-question', name: 'icon-question'},
    {class: 'icon-pie-chart', name: 'icon-pie-chart'},
    {class: 'icon-pencil', name: 'icon-pencil'},
    {class: 'icon-note', name: 'icon-note'},
    {class: 'icon-loop', name: 'icon-loop'},
    {class: 'icon-home', name: 'icon-home'},
    {class: 'icon-grid', name: 'icon-grid'},
    {class: 'icon-graph', name: 'icon-graph'},
    {class: 'icon-microphone', name: 'icon-microphone'},
    {class: 'icon-music-tone-alt', name: 'icon-music-tone-alt'},
    {class: 'icon-music-tone', name: 'icon-music-tone'},
    {class: 'icon-earphones-alt', name: 'icon-earphones-alt'},
    {class: 'icon-earphones', name: 'icon-earphones'},
    {class: 'icon-equalizer', name: 'icon-equalizer'},
    {class: 'icon-like', name: 'icon-like'},
    {class: 'icon-dislike', name: 'icon-dislike'},
    {class: 'icon-control-start', name: 'icon-control-start'},
    {class: 'icon-control-rewind', name: 'icon-control-rewind'},
    {class: 'icon-control-play', name: 'icon-control-play'},
    {class: 'icon-control-pause', name: 'icon-control-pause'},
    {class: 'icon-control-forward', name: 'icon-control-forward'},
    {class: 'icon-control-end', name: 'icon-control-end'},
    {class: 'icon-volume-1', name: 'icon-volume-1'},
    {class: 'icon-volume-2', name: 'icon-volume-2'},
    {class: 'icon-volume-off', name: 'icon-volume-off'},
    {class: 'icon-calendar', name: 'icon-calendar'},
    {class: 'icon-bulb', name: 'icon-bulb'},
    {class: 'icon-chart', name: 'icon-chart'},
    {class: 'icon-ban', name: 'icon-ban'},
    {class: 'icon-bubble', name: 'icon-bubble'},
    {class: 'icon-camrecorder', name: 'icon-camrecorder'},
    {class: 'icon-camera', name: 'icon-camera'},
    {class: 'icon-cloud-download', name: 'icon-cloud-download'},
    {class: 'icon-cloud-upload', name: 'icon-cloud-upload'},
    {class: 'icon-envelope', name: 'icon-envelope'},
    {class: 'icon-eye', name: 'icon-eye'},
    {class: 'icon-flag', name: 'icon-flag'},
    {class: 'icon-heart', name: 'icon-heart'},
    {class: 'icon-info', name: 'icon-info'},
    {class: 'icon-key', name: 'icon-key'},
    {class: 'icon-link', name: 'icon-link'},
    {class: 'icon-lock', name: 'icon-lock'},
    {class: 'icon-lock-open', name: 'icon-lock-open'},
    {class: 'icon-magnifier', name: 'icon-magnifier'},
    {class: 'icon-magnifier-add', name: 'icon-magnifier-add'},
    {class: 'icon-magnifier-remove', name: 'icon-magnifier-remove'},
    {class: 'icon-paper-clip', name: 'icon-paper-clip'},
    {class: 'icon-paper-plane', name: 'icon-paper-plane'},
    {class: 'icon-power', name: 'icon-power'},
    {class: 'icon-refresh', name: 'icon-refresh'},
    {class: 'icon-reload', name: 'icon-reload'},
    {class: 'icon-settings', name: 'icon-settings'},
    {class: 'icon-star', name: 'icon-star'},
    {class: 'icon-symbol-female', name: 'icon-symbol-female'},
    {class: 'icon-symbol-male', name: 'icon-symbol-male'},
    {class: 'icon-target', name: 'icon-target'},
    {class: 'icon-credit-card', name: 'icon-credit-card'},
    {class: 'icon-paypal', name: 'icon-paypal'},
    {class: 'icon-social-tumblr', name: 'icon-social-tumblr'},
    {class: 'icon-social-twitter', name: 'icon-social-twitter'},
    {class: 'icon-social-facebook', name: 'icon-social-facebook'},
    {class: 'icon-social-instagram', name: 'icon-social-instagram'},
    {class: 'icon-social-linkedin', name: 'icon-social-linkedin'},
    {class: 'icon-social-pinterest', name: 'icon-social-pinterest'},
    {class: 'icon-social-github', name: 'icon-social-github'},
    {class: 'icon-social-gplus', name: 'icon-social-gplus'},
    {class: 'icon-social-reddit', name: 'icon-social-reddit'},
    {class: 'icon-social-skype', name: 'icon-social-skype'},
    {class: 'icon-social-dribbble', name: 'icon-social-dribbble'},
    {class: 'icon-social-behance', name: 'icon-social-behance'},
    {class: 'icon-social-foursqare', name: 'icon-social-foursqare'},
    {class: 'icon-social-soundcloud', name: 'icon-social-soundcloud'},
    {class: 'icon-social-spotify', name: 'icon-social-spotify'},
    {class: 'icon-social-stumbleupon', name: 'icon-social-stumbleupon'},
    {class: 'icon-social-youtube', name: 'icon-social-youtube'},
    {class: 'icon-social-dropbox', name: 'icon-social-dropbox'}
    ];
    
    